export enum ErrorSeverity {
    FATAL,
    SERIOUS,
    COMMON,
    WARN
}

export class MessageModel {

    constructor(
        public _headline: string,
        private _details: string[],
    ) {
    }

    get headline(): string {
        return this._headline;
    }

    set headline(value: string) {
        this._headline = value;
    }

    get details(): string[] {
        return this._details;
    }

    set details(value: string[]) {
        this._details = value;
    }

    addDetail(detail: string): void {
        this._details.push(detail);
    }

}

export class ErrorModel extends MessageModel {

    constructor(
        private readonly _severity: ErrorSeverity,
        headline: string,
        details: string[],
        private readonly _httpResponse: Response
    ) {
        super(headline, details);
    }

    get severity(): ErrorSeverity {
        return this._severity;
    }

    get httpResponse(): Response {
        return this._httpResponse;
    }

}

export class ConfirmModel extends MessageModel {

    constructor(
        private readonly _confirmButtonText: string,
        headline: string,
        details: string[],
        private readonly _confirmCallBackFunction: Function,
        private readonly _cancelCallBackFunction: Function,
    ) {
        super(headline, details);
    }

    get confirmButtonText(): string {
        return this._confirmButtonText;
    }

    get confirmCallBackFunction(): Function {
        return this._confirmCallBackFunction;
    }

    get cancelCallBackFunction(): Function {
        return this._cancelCallBackFunction;
    }

}

export class ErweiterteAuftraggeberSucheModel extends MessageModel {

    constructor(
        private readonly _sucheVorbelegung: string,
        private _isHandled: boolean = false
    ) {
        super('Erweiterte Suche', []);
    }

    get sucheVorbelegung(): string {
        return this._sucheVorbelegung;
    }

    get isHandled(): boolean {
        return this._isHandled;
    }

    set isHandled(value: boolean) {
        this._isHandled = value;
    }

}

